import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import SuspanseLoader from "./SuspanseLoader";

const Analytics = lazy(() => import("./pages/retails/Analytics"));
const Dashboard = lazy(() => import("./pages/retails/Dashboard"));
const Demo = lazy(() => import("./pages/retails/Demo"));
const DynamicPricing = lazy(() => import("./pages/retails/DynamicPricing"));
const Invoices = lazy(() => import("./pages/retails/Invoices"));
const MarketAnalysis = lazy(() => import("./pages/retails/MarketAnalysis"));
const PaymentFailure = lazy(() => import("./pages/retails/PaymentFailure"));
const PaymentSuccess = lazy(() => import("./pages/retails/PaymentSuccess"));
const PricingReview = lazy(() => import("./pages/retails/PricingReview"));
const Settings = lazy(() => import("./pages/retails/Settings"));
const Subscription = lazy(() => import("./pages/retails/Subscription"));
const Support = lazy(() => import("./pages/retails/Support"));
const SystemPerformance = lazy(
  () => import("./pages/retails/SystemPerformance"),
);
const TripManagement = lazy(() => import("./pages/retails/TripManagement"));

export const retailsRoutesConfig = [
  {
    index: true,
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <DynamicPricing />
      </Suspense>
    ),
  },
  {
    path: "dashboard",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <DynamicPricing />
      </Suspense>
    ),
  },
  {
    path: "demo",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Demo />
      </Suspense>
    ),
  },
  {
    path: "trips",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <TripManagement />
      </Suspense>
    ),
  },
  {
    path: "analytics",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Analytics />
      </Suspense>
    ),
  },
  {
    path: "customers",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <MarketAnalysis />
      </Suspense>
    ),
  },
  {
    path: "conversion",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PricingReview />
      </Suspense>
    ),
  },
  {
    path: "performance",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <SystemPerformance />
      </Suspense>
    ),
  },
  {
    path: "settings",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Settings />
      </Suspense>
    ),
  },
  {
    path: "support",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Support />
      </Suspense>
    ),
  },
  {
    path: "subscription",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Subscription />
      </Suspense>
    ),
  },
  {
    path: "subscription-enterprise",
    element: <Navigate to="/subscription" replace />,
  },
  {
    path: "invoices",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Invoices />
      </Suspense>
    ),
  },
  {
    path: "reporting",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Dashboard />
      </Suspense>
    ),
  },
  {
    path: "payment/success",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PaymentSuccess />
      </Suspense>
    ),
  },
  {
    path: "payment/failure",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PaymentFailure />
      </Suspense>
    ),
  },
];
